import m from "mithril";
import SearchForm from "./form";
import SearchFormMap from "./form/map";
import SearchFormMrt from "./form/mrt";
import SearchFormList from "./form/list";
import MobileSearchForm from "./form";
import MobileSearchFormList from "./form/list";
import MobileSearchFormMrt from "./form/mrt";
import MobileSearchFormMap from "./form/map";

import CliamForm from "./claim";
import isMobile from "./lib/detect-mobile";
import LikersForm from "./form/liker";

import Liker from "./models/liker";

window.isMobile = isMobile();

const likers = document.querySelectorAll(".collection-button");

const root = document.getElementById("search_bar");
const mobile_root = document.getElementById("mobile_search_bar");
const root_map = document.getElementById("search_bar_map");
const mobile_root_map = document.getElementById("mobile_search_bar_map");
const root_mrt = document.getElementById("search_bar_mrt");
const mobile_root_mrt = document.getElementById("mobile_search_bar_mrt");
const root_list = document.getElementById("search_bar_list");
const mobile_root_list = document.getElementById("mobile_search_bar_list");
const claim = document.getElementById("jjjjjjjjjjj");
// const liker = document.querySelector('.lifer_icon')

if (root != null && !window.isMobile) {
    m.mount(root, SearchForm);
}
if (mobile_root != null && window.isMobile) {
    m.mount(mobile_root, MobileSearchForm);
}
if (root_map != null && !window.isMobile) {
    m.mount(root_map, SearchFormMap);
}
if (mobile_root_map != null && window.isMobile) {
    m.mount(mobile_root_map, MobileSearchFormMap);
}
if (root_mrt != null && !window.isMobile) {
    m.mount(root_mrt, SearchFormMrt);
}
if (mobile_root_mrt != null && window.isMobile) {
    m.mount(mobile_root_mrt, MobileSearchFormMrt);
}
if (root_list != null && !window.isMobile) {
    m.mount(root_list, SearchFormList);
}
if (mobile_root_list != null && window.isMobile) {
    m.mount(mobile_root_list, MobileSearchFormList);
}
if (claim != null) {
    m.mount(claim, CliamForm);
}

// console.log(window.IsAuthenticated)  認證狀況
// window.house = (localStorage.getItem("liker") != null) ? JSON.parse(localStorage.getItem("liker")) : []
//Liker.fetch().then((response) => {
//    window.house = response
//    if (LikersForm != null) {
//        likers.forEach(liker => {
//            m.mount(liker, {
//                view: () => {
//                    return m(LikersForm, {
//                        id: liker.attributes.getNamedItem('data-bind').nodeValue,
//                    })
//                }
//            })
//        });
//    }
//})

// m.mount(claim, CliamForm)
// m.mount(liker, LikerForm)
